import { GetBaseUrl } from "@/utils/ConfigHelper";
import axios from "axios";
import Response from "@/utils/Videomonster/Common/Response";
import { PUBLIC_ERROR_CODE } from "@/utils/Error/Constants";
import { GetPublicErrorCode } from "@/utils/Error/Handler";

const GetAiSourcesHistory = async (token, data) => {
  try {
    const { offset, limit, creditProductIds } = data;
    const url = `${GetBaseUrl()}/apis/ai-sources/history`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      params: { offset, limit, creditProductIds }
    };
    const response = await axios.get(url, config);

    const result = response.status === 200;
    const resultData = response.data.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

const GetAiSourcesState = async (token, data) => {
  try {
    const { aiSourceId } = data;
    const url = `${GetBaseUrl()}/apis/ai-sources/${aiSourceId}/state`;
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const response = await axios.get(url, config);
    const result = response.status === 200;
    const resultData = response.data.data;

    return new Response(result, resultData);
  } catch (e) {
    const publicErrorCode = GetPublicErrorCode(e);
    switch (publicErrorCode) {
      case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
        return new Response(false, publicErrorCode);
      case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
      default:
        throw e;
    }
  }
}

export default {
  GetAiSourcesHistory,
  GetAiSourcesState,
};
